/**
 *
 * @param {string} name userName
 * @returns {string} Initials
 */
 const extractInitials = (name) => {
    try {
        return name
            .split(" ")
            .map((x) => x.charAt(0))
            .join("")
            .substr(0, 2)
            .toUpperCase();
    } catch (e) {
        return name.charAt(0);
    }
};

export const extractName = (name) => {
    if (!name) {
        return name;
    } else {
        if (name.length > 19) return `${name.substr(0,22)}...`;
          else return name;
  }

};

export default extractInitials;
